<template lang="pug">
  div.marginTop
    app-divider(:label="titulo")
    div
      el-row.labelDiv(:gutter="30")
        el-col.inputDiv(:span="16")
          validation-provider(rules="required", v-slot="{ errors }", :name="nomeAba + '/Logradouro'")
            app-label(label="Logradouro:")
            el-input.input(
              name="logradouro",
              v-model="endereco.logradouro",
              maxlength="300"
              :class="{'erro' : errors.length}"
            )
            span.help.erro {{ errors[0] }}

        el-col.inputDiv(:span="8")
          validation-provider(rules="required", v-slot="{ errors }", :name="nomeAba + '/Número'")
            app-label(label="Número:", :required="true")
            el-input.input(
              name='numero'
              v-model="endereco.numero",
              :disabled="endereco.semNumero",
              :onkeypress="onlyInputNumbers",
              maxlength="10"
              :showAppend ="true",
              :class="{'erro' : errors.length}"
            )
              el-checkbox.input(
                v-model="endereco.semNumero",
                label="S/N", slot="prepend",
                @change="onSemNumeroCheck"
              )
            span.help.erro {{ errors[0] }}
      el-row.labelDiv(:gutter="30")
        el-col.inputDiv(:span="12")
          app-label(label="Complemento:", :required='false')
          el-input.input(
            name="complemento",
            maxlength="100"
            v-model="endereco.complemento",
          )
        el-col.inputDiv(:span="12")
          validation-provider(rules="required", v-slot="{ errors }", :name="nomeAba + '/Bairro'")
            app-label(label="Bairro:")
            el-input.input(
              name="bairro",
              v-model="endereco.bairro",
              maxlength="100"
              :class="{'erro' : errors.length}"
            )
            span.help.erro {{ errors[0] }}

      el-row.labelDiv(:gutter="30")
        el-col.inputDiv(:span="4")
          validation-provider(rules="required", v-slot="{ errors }", :name="nomeAba + '/CEP'")
            app-label(label="CEP:")
            el-input.input(
              name="CEP",
              v-model="endereco.cep",
              v-mask="['#####-###']",
              :class="{'erro' : errors.length}"
            )
            span.help.erro {{ errors[0] }}

        el-col.inputDiv(:span="8")
          validation-provider(rules="required", v-slot="{ errors }", :name="nomeAba + '/UF'")
            app-label(label="UF:")
            el-select.input(
              width="100",
              class="select",
              v-model="endereco.uf",
              @change="changeEstado",
              no-match-text="Nenhuma UF encontrada",
              placeholder="Selecione",
              clearable,
              filterable,
              default-first-option=false,
              name="UF",
              :class="{'erro' : errors.length}"
            )
              el-option(v-for="estado in estadosBr",
              :key="estado.codigo",
              :label="estado.nome",
              :value="estado.codigo"
              )
            span.help.erro {{ errors[0] }}

        el-col.inputDiv(:span="12")
          validation-provider(rules="required", v-slot="{ errors }", :name="nomeAba + '/Município'")
            app-label(label="Município:", :required="true")
            el-select.input(
              v-model="endereco.municipio",
              class="select",
              no-match-text="Nenhum município encontrado",
              placeholder="Selecione",
              filterable,
              value-key="id"
              default-first-option=false,
              :disabled="!endereco.uf",
              :class="{'erro' : errors.length}"
              name="municipio",
            )
              el-option(
                v-for="item in municipios",
                :key="item.id",
                :label="item.nome",
                :value="item"
              )
            span.help.erro {{ errors[0] }}
</template>

<script>
import onlyInputNumbers from '@/components/mixins/OnlyInputNumber'
import { mapActions } from 'vuex'
import AppLabel from './AppLabel'
import estadosBr from '@/constants/estados'
import AppDivider from '@/components/AppDivider'

export default {
  mixins: [onlyInputNumbers],

  components: {
    AppLabel,
    AppDivider
  },

  props: {
    endereco: {
      required: true
    },
    nomeAba: {
      type: String,
      required: true
    },
    titulo: {
      type: String,
      required: false,
      default: 'Endereço'
    }
  },

  data () {
    return {
      estadosBr,
      municipios: []
    }
  },

  async created () {
    if (this.endereco.uf) {
      this.municipios = await this.getMunicipiosByUf(this.endereco.uf)
    }
  },

  beforeUpdate () {
    if (!this.endereco.numero && this.endereco.semNumero) {
      this.endereco.numero = 0
    }
  },

  methods: {
    ...mapActions({
      getMunicipiosByUf: 'municipios/findMunicipiosByUf'
    }),

    async changeEstado () {
      this.endereco.municipio = null
    },

    onSemNumeroCheck (checked) {
      if (checked) {
        this.endereco.numero = 0
        return
      }

      this.endereco.numero = null
    }
  },

  watch: {
    'endereco.uf': {
      async handler (oldval, newval) {
        if (oldval !== newval && this.endereco.uf) {
          this.municipios = await this.getMunicipiosByUf(this.endereco.uf)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

  .el-row {
    margin-bottom: 20px;
  }
  .select {
    width: 100%;
  }
  .titulo {
    font-size: 16px;
    box-sizing: border-box;
    font-family: 'Ubuntu', sans-serif;
    font-weight: bold;
  }
  .tittle {
    border: 1px solid #dfe4ed;
    margin-bottom: 15px;
    font-weight: 700;
  }
  .labelDivider {
    color: #606266 !important;
    font-size: 1em;
    margin-top: 25px;
    margin-bottom: 5px;
    font-weight: 600;
  }
  .marginTop {
    margin-top: 15px;
  }

  @media (max-width: 780px) {
    .labelDiv {
      display: flex;
      flex-direction: column;
    }
    .inputDiv {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/AppEndereco.vue